import { render } from "./constrcomponent.vue?vue&type=template&id=b3f137a8&scoped=true"
import script from "./constrcomponent.vue?vue&type=script&lang=js"
export * from "./constrcomponent.vue?vue&type=script&lang=js"

import "./constrcomponent.vue?vue&type=style&index=0&id=b3f137a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f137a8"]])

export default __exports__